import { ca } from '@cian/analytics';
import { useSelector } from 'react-redux';

import { selectIsOfferOwnedByUser, selectOffer, selectOfferId } from 'shared/selectors';
import { selectCpdSource, selectCustomCpdDealType } from 'shared/selectors/cpd/cpd';

export const useCpdTracking = () => {
  const offer = useSelector(selectOffer);
  const offerId = useSelector(selectOfferId);
  const source = useSelector(selectCpdSource);
  const isHomeowner = useSelector(selectIsOfferOwnedByUser);
  const customCpdDealType = useSelector(selectCustomCpdDealType);

  const defaultCpdDealType = isHomeowner ? undefined : 'buy;';
  const cpdDealType = customCpdDealType || defaultCpdDealType;

  const products = [
    {
      id: offerId,
      offerType: 'offer',
      position: 1,
    },
  ];

  const trackCPDTrapVisible = (label: string) => {
    ca('eventSite', {
      name: 'oldevent',
      label,
      action: 'Show_sopr',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          cpdOfferType: offer.category,
          cpdDealType,
        },
      },
    });
  };

  const trackCPDTrapClick = (label: string) => {
    ca('eventSite', {
      name: 'oldevent',
      label,
      action: 'Click',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          cpdOfferType: offer.category,
          cpdDealType,
        },
      },
    });
  };

  const trackCPDModalVisible = () => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'Popup',
      action: 'Open',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          source,
          cpdOfferType: offer.category,
          cpdDealType,
        },
      },
    });
  };

  const trackCPDCreateDraftClick = () => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'Send',
      action: 'Click',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          source,
          cpdOfferType: offer.category,
          cpdDealType,
        },
      },
    });
  };

  const trackCPDDetailClick = () => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'Detail',
      action: 'Click',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          source,
          cpdOfferType: offer.category,
          cpdDealType,
        },
      },
    });
  };

  const trackCPDSuccessScreenVisible = (cpdDraftId?: number) => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'Success',
      action: 'Send',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          source,
          draft_id: cpdDraftId,
          cpdOfferType: offer.category,
          cpdDealType,
        },
      },
    });
  };

  const trackCPDGoToChatClick = (cpdDraftId?: number) => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'ToChat',
      action: 'Click',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          source,
          draft_id: cpdDraftId,
          cpdOfferType: offer.category,
          cpdDealType,
        },
      },
    });
  };

  return {
    trackCPDTrapVisible,
    trackCPDTrapClick,
    trackCPDModalVisible,
    trackCPDCreateDraftClick,
    trackCPDDetailClick,
    trackCPDSuccessScreenVisible,
    trackCPDGoToChatClick,
  };
};
